import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Title from "../../components/about/common/Title";
import BlogImageCard from "../../components/blog/overview/BlogImageCard";
import BlogImageCardSkeleton from "../../components/blog/overview/BlogImageCardSkeleton";
import BlogCard from "../../components/blog/overview/BlogCard";
import BlogCardSkeleton from "../../components/blog/overview/BlogCardSkeleton";
import { makeStyles } from "@material-ui/core/styles";

const NUM_BLOG_IMAGE_PREVIEW = 1;
const NUM_TOTAL_BLOG_POSTS = 3;

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: "5rem",
  },
  card: {
    //  This css part could be replaced by spacing property on the grid container tag, but the padding will be wrong at sm breakpoint
    [theme.breakpoints.down("sm")]: {
      "& ~ &": {
        paddingTop: theme.spacing(4),
      },
      paddingLeft: theme.spacing(0),
    },
    "& ~ &": {
      paddingTop: theme.spacing(4),
    },
    paddingLeft: theme.spacing(2),
  },

  loading: {
    textAlign: "center",
    marginTop: "5em",
  },
}));

const fetchBlogUrl = `https://natakallam.com/wp-json/wp/v2/posts`;

export default function BlogOverview() {
  const classes = useStyles();
  const [isLoad, setIsLoad] = useState(false);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch(fetchBlogUrl)
      .then((respond) => respond.json())
      .then((jsonData) => {
        setBlogs(jsonData);
        setIsLoad(true);
      });
  }, []);

  let blogImageCardComponent = null;
  let blogTextCardComponent = null;
  if (isLoad) {
    blogImageCardComponent = blogs
      .slice(0, NUM_BLOG_IMAGE_PREVIEW)
      .map((blog) => <BlogImageCard key={blog.id} data={blog} />);

    blogTextCardComponent = blogs
      .slice(NUM_BLOG_IMAGE_PREVIEW, NUM_TOTAL_BLOG_POSTS)
      .map((card) => (
        <Grid className={classes.card} item xs={12} key={Math.random()}>
          <BlogCard key={card.id} data={card} />
        </Grid>
      ));
  } else {
    blogImageCardComponent = <BlogImageCardSkeleton />;

    blogTextCardComponent = (
      <>
        <BlogCardSkeleton />
        <BlogCardSkeleton />
      </>
    );
  }

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Box>
        <Grid
          container
          direction="row"
          spacing={4}
          justify="center"
          alignItems="stretch"
        >
          <Grid item xs={12}>
            <Title
              title="Stories From Our Learners"
              description="Stories of hope and inspiration from our learning community"
            />
          </Grid>
          <Grid className={classes.gridStyle} item xs={12} md={6}>
            {blogImageCardComponent}
          </Grid>
          <Grid className={classes.gridStyle} item xs={12} md={6}>
            {blogTextCardComponent}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
